import { map_desktop } from '../map/map.desktop';
import { map_mobile } from '../map/map.mobile';
import States from '../helpers/states';


export default class AutoBindComponents {
    constructor(className, instanceName) {
        this._page = document.body.querySelector('#main .page');
        this._className = className;
        this._instanceName = instanceName;
        this._map = (ENV.device == 'desktop') ? map_desktop : map_mobile;

        window.States = States;
        this.Components = States.Components

        this._autoBind();
    }

    _autoBind() {
        const components = this._page.querySelectorAll('[data-component="'+this._instanceName+'"]');
		for (let i = 0, j = components.length; i < j; i++) {
			const component = components[i];
			if (!component.classList.contains('is-binded')) {
				const name = component.getAttribute('data-component');
				if (this._map.components.hasOwnProperty(name)) {
					if (this.Components.hasOwnProperty(name.capitalize())) {
						if (isArray(this.Components[name.capitalize()])) {
							this.Components[name.capitalize()].push(new this._map.components[name].default(component));
						} else {
							this.Components[name.capitalize()] = [
								this.Components[name.capitalize()],
								new this._map.components[name].default(component)
							];
						}
					} else {
						this.Components[name.capitalize()] = new this._map.components[name].default(component);
					}
				} else {
					throw new Error(`Main${this._device.capitalize()} :: you are calling non-existing '${name}' component in your map file. Please check your map file.`);
				}
			}
		}

		States.Components = this.Components;

		// Rebind
		for (const key in this.Components) {
			if (this.Components.hasOwnProperty(key)) {
                const Component = this.Components[key];
				if (isArray(Component)) {
					for (let i = 0; i < Component.length; i++) {
                        const comp = Component[i];
						if (comp.dom.component.classList.contains(this._className)) {
                            if (!this._getIsBinded(comp.dom.component)) {
                                comp['init'].apply(comp, []);
								comp['resize'].apply(comp, []);
								comp['bind'].apply(comp, []);
                            }
						}
					}
				} else {
					if (Component.dom.component.classList.contains(this._className)) {
						if (!this._getIsBinded(Component.dom.component)) {
							Component['init'].apply(Component, []);
							Component['resize'].apply(Component, []);
							Component['bind'].apply(Component, []);
						}
					}
				}
			}
		}
    }

    _getIsBinded(comp) {
        return (comp.classList.contains('is-binded')) ? true : false;
    }
}



// WEBPACK FOOTER //
// ./src/js/helpers/auto-bind-components.js